import { useMutation } from '@apollo/client';

import { CreateCatalogItemInput } from '__generated__/GQL';
import useCompanyContext from 'common/hooks/useCompanyContext';

import { CatalogItemsDocument } from '../../../../../../hooks/useCatalogItemsQuery/graphql/catalogItems.gql';
import { CreateCatalogItemDocument } from './graphql/createCatalogItem.gql';

const useCreateCatalogItemMutation = () => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error(
      'companyProfileId is undefined in useCreateCatalogItemMutation',
    );
  }

  const [mutation, hook] = useMutation(CreateCatalogItemDocument);

  const createCatalogItem = (
    input: Omit<CreateCatalogItemInput, 'companyProfileId'>,
  ) =>
    mutation({
      awaitRefetchQueries: true,
      refetchQueries: [CatalogItemsDocument],
      variables: {
        input: {
          companyProfileId,
          ...input,
        },
      },
    });

  return [createCatalogItem, hook] as const;
};

export default useCreateCatalogItemMutation;
